import React from "react";
import { NavLink } from "react-router-dom";
import { STORIES } from "../../../constants/images";

export default function StoryCard({
  content,
  createdDate,
  writer,
  storyId,
  txHash,
  isOwner,
  setDeleteStoryModal,
  setDeletingStoryID,
}) {
  return (
    <div className="storyCard">
      <div className="info">
        <div>
          <h5>{new Date(parseInt(createdDate, 16) * 0.001).toDateString()}</h5>
          <div className="by-hex">
            By{" "}
            <NavLink className="writerHex" to={`/wallet/${writer}`}>
              {writer.slice(0, 12)}...
            </NavLink>{" "}
          </div>
        </div>
        <div className="d-flex">
          {isOwner ? (
            <div className="delete-tt">
              <div className="deleteText-tt hover-text">Hide Story</div>
              <img
                src={STORIES.DELETE}
                onClick={async () => {
                  await setDeletingStoryID(parseInt(storyId));
                  setDeleteStoryModal(true);
                }}
              />
            </div>
          ) : null}
          <div className="tracker-tt">
            {/* <a

              target="_blank"
              className="txAnchor"
              style={{ backgroundImage: `url(${STORIES.HYPERLINK})` }}
            > */}
            <img
              onClick={() => {
                window.open(
                  `https://tracker.icon.foundation/transaction/${txHash}`,
                  "_blank"
                );
              }}
              src={STORIES.HYPERLINK}
            />
            {/* </a> */}
            <div className="trackerText-tt hover-text">View on Tracker</div>
          </div>
        </div>
      </div>
      <div className="body">{content}</div>
    </div>
  );
}
